import { Card } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Info } from 'lucide-react';

export function SettingsSection() {
  return (
    <Card className="p-6">
      <h3 className="text-xl font-bold mb-4">إعدادات الموقع</h3>
      <Alert>
        <Info className="h-4 w-4" />
        <AlertDescription>
          قسم إعدادات الموقع قيد التطوير. سيتم إضافة المزيد من الميزات قريباً.
        </AlertDescription>
      </Alert>
    </Card>
  );
}

